(function () {
  "use strict";

  window._theme = window._theme || {};

  // Shared image for slider arrows
  const SLIDER_ARROW_IMG = '//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481';

  // Accessibility Callback for Focus Management in Slick
  const createSliderCallback = function (slick) {
    if (!slick || !slick.$slider) return;
    const FOCUSABLE_SELECTOR = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]';
    
    const sliderEl = slick.$slider[0];
    if (sliderEl) {
      const slides = sliderEl.querySelectorAll('.slick-slide');
      slides.forEach(function (slide) {
        const isQueryActive = slide.classList.contains('slick-active');
        const focusables = slide.querySelectorAll(FOCUSABLE_SELECTOR);
        focusables.forEach(function (focusable) {
          focusable.setAttribute('tabindex', isQueryActive ? '0' : '-1');
        });
      });
    }
  };

  // Helper to initialize discount banner slider
  const initDiscountBannerSlider = function () {
    const bannerSlider = document.querySelector('[data-black-friday-slider]');
    if (!bannerSlider || bannerSlider.classList.contains('slick-initialized')) {
      return;
    }

    _theme.initSlickSlider(jQuery(bannerSlider), {
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow: `<button type='button' tabindex='0' role='button' class='slick-arrow slick-prev'><img src='${SLIDER_ARROW_IMG}' alt=''><span class='sr-only'>Previous</span></button>`,
      nextArrow: `<button type='button' tabindex='0' role='button' class='slick-arrow slick-next'><img src='${SLIDER_ARROW_IMG}' alt=''><span class='sr-only'>Next</span></button>`,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    }, createSliderCallback, createSliderCallback);
  };

  // Helper to initialize black friday collection/product list slider
  const initBlackFridaySlider = function (slider) {
    if (!slider || slider.classList.contains('slick-initialized')) {
      return;
    }

    // Remove skeleton wrapper before initialization to avoid it counting as a slide
    const skeleton = slider.querySelector('.product-skelton-wrapper');
    if (skeleton) {
      skeleton.remove();
    }

    const blackFridaySliderConfig = {
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow: `<button type='button' tabindex='0' role='button' class='slick-arrow slick-prev'><img src='${SLIDER_ARROW_IMG}' alt=''><span class='sr-only'>Previous</span></button>`,
      nextArrow: `<button type='button' tabindex='0' role='button' class='slick-arrow slick-next'><img src='${SLIDER_ARROW_IMG}' alt=''><span class='sr-only'>Next</span></button>`,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    };

    let currentConfig = JSON.parse(JSON.stringify(blackFridaySliderConfig));
    const vTemplate = document.body.getAttribute('data-template');

    // Only override from schema for Valentine's templates
    if (vTemplate === 'collection.valentines' || vTemplate === 'collection.valentines-day-gift-guide') {
      const slidesDesktop = parseFloat(slider.getAttribute('data-slides-desktop')) || 4;
      const slidesTablet = parseFloat(slider.getAttribute('data-slides-tablet')) || 2.5;
      const slidesMobile = parseFloat(slider.getAttribute('data-slides-mobile')) || 1.5;

      currentConfig.slidesToShow = slidesDesktop;
      currentConfig.slidesToScroll = Math.floor(slidesDesktop) || 1;
      currentConfig.infinite = false;
      currentConfig.variableWidth = false;
      currentConfig.centerMode = false;
      currentConfig.edgeFriction = 0;

      currentConfig.responsive.forEach(breakpoint => {
        if (breakpoint.breakpoint === 992 || breakpoint.breakpoint === 1199) {
          breakpoint.settings.slidesToShow = slidesTablet;
        } else if (breakpoint.breakpoint === 768) {
          breakpoint.settings.slidesToShow = slidesMobile;
        }
        breakpoint.settings.slidesToScroll = Math.floor(breakpoint.settings.slidesToShow) || 1;
        breakpoint.settings.centerMode = false;
        breakpoint.settings.infinite = false;
      });
    }

    _theme.initSlickSlider(jQuery(slider), currentConfig, createSliderCallback, createSliderCallback);
  };

  // DOM Ready Check & Initializations
  const initAllSliders = function () {
    // Initialize banner slider
    initDiscountBannerSlider();

    // Initialize slider for non-tab mode
    const nonTabSliders = document.querySelectorAll('.slider-black-friday:not([class*="slider-black-friday-"])');
    nonTabSliders.forEach(function (slider) {
      initBlackFridaySlider(slider);
    });

    // Initialize sliders for tab mode (only visible tabs)
    const activeTabSliders = document.querySelectorAll('.black-friday-collection .tab-content-panel.active .slider-black-friday');
    activeTabSliders.forEach(function (slider) {
      initBlackFridaySlider(slider);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Tab switching functionality with Event Delegation
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.black-friday-collection .tab-button');
    if (!button) return;

    e.preventDefault();
    const collection = button.closest('.black-friday-collection');
    if (!collection) return;

    const tabId = button.getAttribute('data-tab-id');

    // Update tab buttons
    const tabButtons = collection.querySelectorAll('.tab-button');
    tabButtons.forEach(function (btn) {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('tabindex', '-1');
    });

    button.classList.add('active');
    button.setAttribute('aria-selected', 'true');
    button.setAttribute('tabindex', '0');

    // Update tab panels
    const tabPanels = collection.querySelectorAll('.tab-content-panel');
    tabPanels.forEach(function (panel) {
      panel.classList.remove('active');
      panel.setAttribute('hidden', 'hidden');
    });

    const activePanel = collection.querySelector(`.tab-content-panel[data-block-id="${tabId}"]`);
    if (activePanel) {
      activePanel.classList.add('active');
      activePanel.removeAttribute('hidden');

      // Initialize or refresh slider for newly visible tab
      const newSlider = activePanel.querySelector('.slider-black-friday');
      if (newSlider) {
        if (newSlider.classList.contains('slick-initialized')) {
          jQuery(newSlider).slick('setPosition');
          jQuery(newSlider).slick('slickGoTo', 0, true);
        } else {
          initBlackFridaySlider(newSlider);
        }
      }
    }
  });

  // Keyboard navigation for tabs with Event Delegation
  document.addEventListener('keydown', function (e) {
    const button = e.target.closest('.black-friday-collection .tab-button');
    if (!button) return;

    const tabsWrapper = button.closest('.tabs-wrapper');
    if (!tabsWrapper) return;

    const tabs = Array.from(tabsWrapper.querySelectorAll('.tab-button'));
    const currentIndex = tabs.indexOf(button);

    const selectTab = function (index) {
      const targetTab = tabs[index];
      if (targetTab) {
        targetTab.focus();
        targetTab.click();
      }
    };

    const keyHandlers = {
      ArrowRight: () => selectTab((currentIndex + 1) % tabs.length),
      ArrowLeft: () => selectTab((currentIndex - 1 + tabs.length) % tabs.length),
      Home: () => selectTab(0),
      End: () => selectTab(tabs.length - 1),
    };

    if (keyHandlers[e.key]) {
      e.preventDefault();
      keyHandlers[e.key]();
    }
  });

})();
